<template>
    <fullscreen-drawer
        v-if="featureFlags['live-site-responsive-design']"
        :visible="visible"
        @close="handleClose"
    >
        <RemovePayoutMethod
            v-if="isRemoveConfirmationVisible"
            :payout-method="payoutMethod"
            :is-default="isDefault"
            @success="handleRemoved"
            @cancel="handleCancel"
        />

        <DebitCardForm
            v-else
            :mode="PAYOUT_METHOD_MODE_EDIT"
            :payout-account="payoutAccount"
            :payout-method="payoutMethod"
            @success="handleUpdated"
            @remove="handleRemove"
        />
    </fullscreen-drawer>

    <g-drawer
        v-else
        :visible="visible"
        :wrap-style="wrapStyle"
        height="100%"
        get-container="#app"
        placement="bottom"
        @close="handleClose"
    >
        <RemovePayoutMethod
            v-if="isRemoveConfirmationVisible"
            :payout-method="payoutMethod"
            :is-default="isDefault"
            @success="handleRemoved"
            @cancel="handleCancel"
        />

        <DebitCardForm
            v-else
            :mode="PAYOUT_METHOD_MODE_EDIT"
            :payout-account="payoutAccount"
            :payout-method="payoutMethod"
            @success="handleUpdated"
            @remove="handleRemove"
        />
    </g-drawer>
</template>

<script>
    import { computed } from 'vue-demi';
    import { message } from '@grininc/grin-ui';
    import {
        PAYOUT_METHOD_UPDATED_SUCCESS_MESSAGE,
        PAYOUT_METHOD_REMOVED_SUCCESS_MESSAGE,
        PAYOUT_METHOD_MODE_EDIT
    } from '../../../../../app-v2/constants/payouts';
    import useToggle from '../../../../composables/use-toggle';
    import DebitCardForm from './DebitCardForm';
    import RemovePayoutMethod from './RemovePayoutMethod';
    import FullscreenDrawer from "../../../../../app-v2/components/library/FullscreenDrawer";
    import {useFeatureFlagsStore} from "../../../../../stores";

    export default {
        name: 'EditDebitCardDrawer',

        props: {
            visible: {
                type: Boolean,
                default: false
            },
            payoutAccount: {
                type: Object,
                default: null
            },
            payoutMethod: {
                type: Object,
                default: null
            }
        },

        components: {
            FullscreenDrawer,
            DebitCardForm,
            RemovePayoutMethod
        },

        setup(props, context) {
            const featureFlags = useFeatureFlagsStore().data;

            const wrapStyle = {
                position: 'absolute'
            };

            const isDefault = computed(() => {
                return props.payoutMethod?.id === props.payoutAccount?.payout_method_id;
            });

            const {
                currentValue: isRemoveConfirmationVisible,
                setTrue: showRemoveConfirmation,
                setFalse: hideRemoveConfirmation
            } = useToggle(false);

            const handleClose = () => {
                context.emit('close');
                hideRemoveConfirmation();
            };

            const handleUpdated = () => {
                message.success(PAYOUT_METHOD_UPDATED_SUCCESS_MESSAGE);
                context.emit('refresh-payout-account');
                handleClose();
            };

            const handleRemove = () => {
                showRemoveConfirmation();
            };

            const handleRemoved = () => {
                message.success(PAYOUT_METHOD_REMOVED_SUCCESS_MESSAGE);
                context.emit('refresh-payout-account');
                handleClose();
            };

            const handleCancel = () => {
                hideRemoveConfirmation();
            };

            return {
                PAYOUT_METHOD_MODE_EDIT,
                wrapStyle,
                isDefault,
                isRemoveConfirmationVisible,
                featureFlags,

                handleClose,
                handleUpdated,
                handleRemove,
                handleRemoved,
                handleCancel
            };
        }
    };
</script>
